import React from 'react';
import { useSelector } from 'react-redux';

import { getUser, isAuth } from '../../redux/selector/User';
import { goToDiscordLogin } from '../../service/functions';

import {
  StyledAvatarContainer,
  StyledAvatar,
  StyledDropdownList,
  StyledTitle,
  StyledItem,
  StyledFooter,
  StyledName,
  StyledTextNavLink,
  DiscordLogoIcon,
} from './styled';
import { dataForSidebar } from '../../redux/selector/Sidebar';

const UserDropdown = ({
  extend = false,
  showLegal = false,
  openInvitePopupCallback = () => {},
  openSettingsCallback = () => {},
  logoutCallback = () => {},
  leaveGameCallback = () => {},
  showTutorialCallback = () => {},
}) => {
  const { avatarID, username, discord } = useSelector(getUser);
  const isAuthenticated = useSelector(isAuth);
  const { second_user } = useSelector(dataForSidebar);

  const avatarUrl = `https://cdn.discordapp.com/avatars/${discord}/${avatarID}.jpg`;

  return (
    <StyledDropdownList>
      {extend && (
        <StyledTitle>
          <StyledAvatarContainer>
            {isAuthenticated ? (
              <StyledAvatar src={avatarUrl} alt="avatar" />
            ) : (
              <DiscordLogoIcon onClick={() => goToDiscordLogin()} />
            )}
          </StyledAvatarContainer>
          <StyledName>{username}</StyledName>
        </StyledTitle>
      )}
      <StyledItem
        isDefaultStyles
        onClick={() => {
          openInvitePopupCallback();
        }}
      >
        Invite a Friend
      </StyledItem>
      <StyledItem isDefaultStyles onClick={() => showTutorialCallback()}>
        Tutorial
      </StyledItem>
      <StyledItem isDefaultStyles onClick={() => openSettingsCallback()}>
        Appearance
      </StyledItem>
      {showLegal && (
        <>
          <StyledTextNavLink
            to="/privacy"
            target="_blank"
            rel="noreferrer noopener"
            href="#"
          >
            Privacy
          </StyledTextNavLink>
          <StyledTextNavLink
            to="/terms"
            target="_blank"
            rel="noreferrer noopener"
            href="#"
          >
            Terms of use
          </StyledTextNavLink>
        </>
      )}
      <StyledItem
        isAuthenticated={isAuthenticated}
        onClick={() => {
          if (isAuthenticated) {
            logoutCallback();
          }
        }}
      >
        Logout
      </StyledItem>
      <StyledFooter
        isAuthenticated={isAuthenticated}
        onClick={() => {
          if (isAuthenticated) {
            leaveGameCallback();
          }
        }}
      >
        {second_user ? 'Leave team' : 'Leave game'}
      </StyledFooter>
    </StyledDropdownList>
  );
};
export default UserDropdown;
